import state from '@/vuex/ui/state.js'
import getters from '@/vuex/ui/getters.js'
import mutations from '@/vuex/ui/mutations.js'
import actions from '@/vuex/ui/actions.js'

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module



// WEBPACK FOOTER //
// ./src/vuex/ui/module.js